export default class FiscalSalesZreportController {
  constructor(FiscalPrinterService, $state, AuthService, FileUploader, moment) {
    this.service = FiscalPrinterService;
    this.state = $state;
    this.auth = AuthService;
    this.fileUploader = new FileUploader({
       url: this.service.host + '/api/accounts/fiscal-printer/z-report',
       headers: {
         Authorization: `Bearer ${this.auth.getToken()}`,
         'X-Account-Token': this.auth.getAccountToken()
       },
       removeAfterUpload: true
    });
    this.moment = moment;
  }

  $onInit(){
    this.rows = [];
    this.fileUploader.onSuccessItem = (item, response, status, headers) => {
      this.rows = this.rows.concat(response.results);
    }
  }
  uploadAllFiles(){
    this.fileUploader.uploadAll();
  }
}

 FiscalSalesZreportController.$inject = ['FiscalPrinterService', '$state', 'AuthService', 'FileUploader', 'moment'];

 


// WEBPACK FOOTER //
// ./src/app/pages/fiscal-sales-zreport/fiscal-sales-zreport.controller.js